export enum HubSettingType {
  SHOW_FEED = 'SHOW_FEED',
  SHOW_COURSE = 'SHOW_COURSE',
  SHOW_PROGRAMS = 'SHOW_PROGRAM',
  SHOW_VIDEO = 'SHOW_VIDEO',
  SHOW_EVENTS = 'SHOW_EVENT',
  SHOW_GROUPS = 'SHOW_GROUP',
  SHOW_CLINICAL_CASES = 'SHOW_CASE',
  SHOW_MEMBERS = 'SHOW_MEMBER',
  SHOW_ABOUT = 'SHOW_ABOUT',
  SHOW_EVALUATIONS = 'SHOW_EVALUATIONS',
}
